import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=5564c0ff&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5564c0ff')) {
      api.createRecord('5564c0ff', component.options)
    } else {
      api.reload('5564c0ff', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=5564c0ff&", function () {
      api.rerender('5564c0ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/Sidebar/SidebarItem.vue"
export default component.exports